import firebase from "firebase";

const config = {
    apiKey: "AIzaSyCO3Uh6gphYt7GfZGbgiYJHDZKjb9omkx4",
    authDomain: "wccm-calendar.firebaseapp.com",
    databaseURL: "https://wccm-calendar.firebaseio.com",
    projectId: "wccm-calendar",
    storageBucket: "wccm-calendar.appspot.com",
    messagingSenderId: "902852882919",
    appId: "1:902852882919:web:8a0d75280b4777b9cacd42",
    measurementId: "G-5B3649K3KW"
};
firebase.initializeApp(config);

export const db = firebase.firestore()
export const storage = firebase.storage().ref()